import React, { useContext, useEffect, useState } from "react";
import AuthContext from "../context/AuthContext";
import { toast } from "wc-toast";
import { apiGet,apiPost } from "../utils/apiFetch";
import apiPath from "../utils/apiPath";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Table,
  Modal,
  Button,
  Form,
} from "react-bootstrap";
import helpers from "../utils/helpers";
import { FaRegCopy } from "react-icons/fa6";
import CopyToClipboard from "react-copy-to-clipboard";
import { useForm } from "react-hook-form";

const Dashboard = () => {
   const {
      register,
      handleSubmit,
      formState: { errors },
      reset,
      setValue,
      watch,
    } = useForm({});
 var previousDate = moment().subtract(1, "days").format("YYYY-MM-DD");
  var currentDate = moment().format("YYYY-MM-DD");
  const { user } = useContext(AuthContext);
  const [topData, setTopdata] = useState({});
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState({
    fromPeriod: previousDate,
    toPeriod: currentDate,
  });
const [code, setCode] = useState({
      status: false,
      item: "",
    });
  const getTopAmount = async () => {
    const { status, data: response_users } = await apiGet(apiPath.riskProfile);
    if (status === 200) {
      if (response_users.success) {
        if (response_users.results) {
          setTopdata(response_users.results);
        }
      }
    }
  };
const updateRefrel = async (request) => {
    const { status, data: response_users } = await apiPost(
      apiPath.updateRefrelCode,
      { referalCode: request?.referalCode }
    );
    if (status === 200) {
      if (response_users.success) {
        toast.success(response_users.message);
        myProfile();
        setCode({ status: false });
        reset();
      } else {
        toast.error(response_users.message);
      }
    }
  };
  const getDashboard = async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.dashboard,
      filter
    );
    if (status === 200) {
      if (response_users.success) {
        if (response_users.results) {
          setData(response_users.results);
        }
      }
    }
  };

  useEffect(() => {
    getTopAmount();
    getDashboard();
  }, []);

  useEffect(() => {
    const intervalID = setInterval(() => {
      getTopAmount();
    }, 30 * 1000);

    return () => clearInterval(intervalID);
  }, []);

  const Color = (value) => {
    if (value > 0) {
      return "green";
    } else {
      return "red";
    }
  };

  // Function to copy referral code
  function copy(text) {
    toast.success("Link Copied!");
    return window.navigator.clipboard.writeText(text);
  }

  const [profileData, setProfileData] = useState({});

  // Fetch profile data
  const myProfile = async () => {
    const { status, data: response_users } = await apiGet(apiPath.userProfile);
    if (status === 200 && response_users.success) {
      setProfileData(response_users.results);
    }
  };

  useEffect(() => {
    myProfile();
  }, []);
  
  // console.log('user ', user);

  return (
    <div>
         <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              paddingTop: "10px",
              fontSize: "15px",
              // border: "#ccc thin solid",
              background: "#fff",
              marginTop: "15px",
              marginLeft: "22px",
              borderRadius: "20px",
              padding: "5px 0",
            }}
          >
            {(user?.userType == "agent") && (
            <>
            <span style={{ paddingLeft: "12px" }}>User Referral Code:</span>
            <span
              style={{
                cursor: "pointer",
                color: "#000",
                paddingLeft: "5px",
                background: "#00f4fe",
                // borderRadius: "20px",
                padding: "5px 20px",
                margin: "0 5px",
              }}
              onClick={() => {
                copy(
                  `https://${window.location.hostname.replace(/^(www|ag|msa|bxawscf|velki|aff)\./, "")}/register?referral_code=${profileData?.referalCode}`
                );
              }}
              className="text-start"
            >
              {profileData?.referalCode
                ? `https://${window.location.hostname.replace(/^(www|ag|msa|bxawscf|velki|aff)\./, "")}/register?referral_code=${profileData?.referalCode}`
                : "-"}
            </span>
             <span title="Edit Agent" style={{ cursor: "pointer" }}
            onClick={() => {
                                      setCode({ ...code, status: true });
                                      setValue(
                                        "referalCode",
                                        profileData?.referalCode
                                      );
                                    }}
                                    >
             <i

                          class="fa fa-pencil"
                          aria-hidden="true"
                        ></i>
            </span>
            </>

            )}

            {((user?.userType == "agent" && user?.platformType == "B2B") || (user?.userType == "sub_admin" && user?.platformType == "B2C")) ? (
            <a
              href="/assets/b2b-b2c-payapp.apk"
              className="text-primary"
              style={{
                textDecoration: "none",
                fontSize: "18px",
                color: "#000",
                padding: "10px 20px",
                backgroundColor: "#00f4fe",
                borderRadius: "8px",
                margin:"0 50px 0 50px"
              }}
              download>
              <span> <i

                          class="fa fa-download"
                          aria-hidden="true"
                        ></i> Payment Deposit App (.APK File)</span>
            </a>):""}
           
          </div>
      
<section className="find-member-sec">
        <Container fluid>
          <h4 className="page-title">Dashboard</h4>
          <Row className="mb-md-0 mb-lg-3 mb-3 p-3 dashboard-header">
            <Col xl={2} lg={2} md={3} sm={6}>
              <div className="">
                <span>From Date :</span>
                <Form.Control
                  onChange={(e) =>
                    setFilter({
                      ...filter,
                      fromPeriod: e.target.value,
                      filterByDay: "",
                    })
                  }
                  max={new Date().toISOString().split("T")[0]}
                  value={filter.fromPeriod}
                  type="date"
                />
              </div>
            </Col>
            <Col xl={2} lg={2} md={3} sm={6}>
              <div className="">
                <span>To Date :</span>
                <Form.Control
                  onChange={(e) =>
                    setFilter({
                      ...filter,
                      fromPeriod: e.target.value,
                      filterByDay: "",
                    })
                  }
                  max={new Date().toISOString().split("T")[0]}
                  value={filter.toPeriod}
                  type="date"
                />
              </div>
            </Col>
            <Col
              xl={2}
              lg={2}
              md={3}
              className="d-flex justify-content-start align-items-end"
            >
              <Button
                onSubmit={() => getDashboard()}
                className="theme_dark_btn"
                style={{
                  marginRight: "10px",
                  border: "none",
                }}
              >
                Submit
              </Button>
              <Button className="theme_light_btn">Reset</Button>
            </Col>
          </Row>
          <Row className="mb-lg-3 mb-xl-3 mb-md-3 mb-sm-3 mb-xs-0 p-0">
            <Col
              xl={2}
              lg={2}
              md={3}
              xs={6}
              className="mb-3 mb-md-0 mb-lg-0 mb-sm-0 pe-2 pe-xs-0"
            >
              <div className="dashboard-single">
                <span>P&L</span>
                <span style={{ color: Color(data?.pl) }} className="second">
                  {Math.abs(data?.pl)}
                </span>
              </div>
            </Col>
            <Col
              xl={2}
              lg={2}
              md={3}
              xs={6}
              className="mb-3 mb-md-0 mb-lg-0 mb-sm-0 ps-2 ps-xs-0"
            >
              <div className="dashboard-single">
                <span>COMMISSION</span>
                <span className="second">{data?.commission}</span>
              </div>
            </Col>
            <Col
              xl={2}
              lg={2}
              md={3}
              xs={6}
              className="mb-3 mb-md-0 mb-lg-0 mb-sm-0 pe-2 pe-xs-0"
            >
              <div className="dashboard-single">
                <span>DEPOSIT</span>
                <span style={{ color: "green" }} className="second">
                  {data?.depositBalance}
                </span>
              </div>
            </Col>
            <Col
              xl={2}
              lg={2}
              md={3}
              xs={6}
              className="mb-3 mb-md-0 mb-lg-0 mb-sm-0 ps-2 ps-xs-0"
            >
              <div className="dashboard-single">
                <span>WITHDRAWAL</span>
                <span style={{ color: "red" }} className="second">
                  {data?.withdrawalBalance}
                </span>
              </div>
            </Col>
            <Col
              xl={2}
              lg={2}
              md={3}
              xs={6}
              className="mb-3 mb-md-0 mb-lg-0 mb-sm-0 pe-2 pe-xs-0"
            >
              <div className="dashboard-single">
                <span>TOTAL BETS</span>
                <span className="second">{data?.totalBets}</span>
              </div>
            </Col>
            <Col
              xl={2}
              lg={2}
              md={3}
              xs={6}
              className="mb-3 mb-md-0 mb-lg-0 mb-sm-0 ps-2 ps-xs-0"
            >
              <div className="dashboard-single">
                <span>SPORTBOOK P&L</span>
                <span
                  style={{ color: Color(data?.sportBookPL) }}
                  className="second"
                >
                  {Math.abs(data?.sportBookPL)}
                </span>
              </div>
            </Col>
          </Row>
          <Row className="mb-lg-3 mb-xl-3 mb-md-3 mb-sm-3 mb-xs-0 p-0">
            <Col xl={4} lg={4} md={6} className="mb-3">
              <div className="dashboard-single">
                <span>Top 10 Matched Amount Player</span>
                <Table className="dashboard-single-tabel">
                  <thead>
                    <tr>
                      <th>UID</th>
                      <th>Exposure</th>
                      <th>Matched Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {topData?.matched?.slice(0, 5)?.length > 0 ? (
                      topData?.matched?.slice(0, 5)?.map((res, index) => {
                        return (
                          <tr>
                            <td>
                              {" "}
                              <Link
                                to={`/currentBets/${res._id}/${res.userType}`}
                              >
                                {index + 1} <a href="#">{res.username}</a>
                              </Link>
                            </td>
                            <td>
                              <strong className="text-danger">
                                ( {helpers.currencyFormat(res.exposure)}){" "}
                              </strong>
                            </td>
                            <td>{helpers.currencyFormat(res.totalAmount)}</td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan={3}>No Record Found</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
                {topData?.matched?.length == 10 && (
                  <div className="w-100 d-flex justify-content-end align-items-center p-2">
                    {" "}
                    <Button
                      onClick={() => navigate("/matchedAll")}
                      className="green-btn p-1"
                    >
                      View All
                    </Button>
                  </div>
                )}
              </div>
            </Col>
            <Col xl={4} lg={4} md={6} className="mb-3">
              <div className="dashboard-single">
                <span>Top 10 Exposure Player</span>
                <Table className="dashboard-single-tabel">
                  <thead>
                    <tr>
                      <th>UID</th>
                      <th>Exposure</th>
                      <th>Matched Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {topData?.exposure?.slice(0, 5)?.length > 0 ? (
                      topData?.exposure?.slice(0, 5)?.map((res, index) => {
                        return (
                          <tr>
                            <td>
                              {" "}
                              <Link
                                to={`/currentBets/${res._id}/${res.userType}`}
                              >
                                {index + 1} <a href="#">{res.username}</a>
                              </Link>
                            </td>
                            <td>
                              <strong className="text-danger">
                                ( {helpers.currencyFormat(res.exposure)}){" "}
                              </strong>
                            </td>
                            <td>{helpers.currencyFormat(res.totalAmount)}</td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan={3}>No Record Found</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
                {topData?.matched?.length == 10 && (
                  <div className="w-100 d-flex justify-content-end align-items-center p-2">
                    {" "}
                    <Button
                      onClick={() => navigate("/matchedAll")}
                      className="green-btn p-1"
                    >
                      View All
                    </Button>
                  </div>
                )}
              </div>
            </Col>
            <Col xl={4} lg={4} md={6} className="mb-3 mb-md-0 mb-lg-0 mb-sm-0">
              <div className="dashboard-single">
                <span>USER COUNT</span>
                <Table className="dashboard-single-tabel">
                  <thead>
                    <tr>
                      <th scope="col">Role</th>
                      <th scope="col" className="text-end">
                        Count
                      </th>
                    </tr>
                  </thead>
                  <tbody></tbody>
                </Table>
              </div>
            </Col>

            {/* <Col xl={3} lg={3} md={6} className="mb-3 mb-md-0 mb-lg-0 mb-sm-0">
              <div className="dashboard-single">
                <span>TOP 5 LOSING MARKET</span>
                <Table className="dashboard-single-tabel">
                  <thead>
                    <tr>
                      <th scope="col">Player</th>
                      <th scope="col" className="text-end">
                        Amount
                      </th>
                    </tr>
                  </thead>
                  <tbody></tbody>
                </Table>
              </div>
            </Col> */}
          </Row>
          <Row className="mb-lg-3 mb-xl-3 mb-md-3 mb-sm-3 mb-xs-0 p-0">
            <Col xl={4} lg={4} md={6} className="mb-3 mb-md-0 mb-lg-0 mb-sm-0">
              <div className="dashboard-single">
                <span>TOP 10 WINNING PLAYER</span>
                <Table className="dashboard-single-tabel">
                  <thead>
                    <tr>
                      <th scope="col">Player</th>
                      <th scope="col" className="text-end">
                        Amount
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.winningUser?.length > 0 ? (
                      data?.winningUser?.map((res, index) => {
                        return (
                          <tr>
                            <td>{res?.username}</td>
                            <td
                              className="text-end"
                              style={{ color: Color(res?.amount) }}
                            >
                              {Math.abs(res?.amount).toFixed()}
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan={2}>No Record Found</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </Col>
            <Col xl={4} lg={4} md={6} className="mb-3 mb-md-0 mb-lg-0 mb-sm-0">
              <div className="dashboard-single">
                <span>TOP 10 LOSING PLAYER</span>
                <Table className="dashboard-single-tabel">
                  <thead>
                    <tr>
                      <th scope="col">Player</th>
                      <th scope="col" className="text-end">
                        Amount
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.loosingUser?.length > 0 ? (
                      data?.loosingUser?.map((res, index) => {
                        return (
                          <tr>
                            <td>{res?.username}</td>
                            <td
                              className="text-end"
                              style={{ color: Color(res?.amount) }}
                            >
                              {Math.abs(res?.amount).toFixed()}
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan={2}>No Record Found</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </Col>

            <Col xl={4} lg={4} md={6} className="mb-3 mb-md-0 mb-lg-0 mb-sm-0">
              <div className="dashboard-single">
                <span>SPORTS GAMEPLAY DETAILS</span>
                <Table className="dashboard-single-tabel">
                  <thead>
                    <tr>
                      <th scope="col">Player</th>
                      <th scope="col" className="text-end">
                        Amount
                      </th>
                    </tr>
                  </thead>
                  <tbody></tbody>
                </Table>
              </div>
            </Col>
          </Row>
          {["owner", "admin", "sub_owner", "super_agent"].includes(
            user?.userType
          ) && (
            <Row className="mb-md-0 mb-lg-3 mb-0 p-0">
              <Col
                xl={6}
                lg={6}
                md={6}
                className="mt-3 mt-md-3 mt-lg-0 mt-sm-0"
              >
                <div className="dashboard-single">
                  <span className="d-flex justify-content-between align-items-center">
                    Pending Registration{" "}
                    <p
                      onClick={() => navigate("/registeredUser/pending")}
                      className="p-0 m-0"
                      style={{ textDecoration: "underline", cursor: "pointer" }}
                    >
                      ...view all
                    </p>
                  </span>
                  <Table className="dashboard-single-tabel">
                    <thead>
                      <tr>
                        {" "}
                        <th scope="col">Sr No.</th>
                        <th scope="col">Mobile Number</th>
                      </tr>
                    </thead>
                    <tbody>
                      {topData?.OTPLog?.length > 0 ? (
                        topData?.OTPLog?.map((res, index) => {
                          return (
                            <tr>
                              <td>{index + 1}</td>
                              <td>
                                <div className="d-flex justify-content-between align-items-center bg-white">
                                  <span className="bg-white text-dark">
                                    {res?.phone_number1}
                                  </span>
                                  <CopyToClipboard
                                    onCopy={() => toast.success("Copied!")}
                                    text={res?.phone_number1 || "-"}
                                  >
                                    <FaRegCopy style={{ cursor: "pointer" }} />
                                  </CopyToClipboard>
                                </div>{" "}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={2}>No Record Found</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </Col>{" "}
              <Col
                xl={6}
                lg={6}
                md={6}
                className="mt-3 mt-md-3 mt-lg-0 mt-sm-0"
              >
                <div className="dashboard-single">
                  <span className="d-flex justify-content-between align-items-center">
                    Recent Registration{" "}
                    <p
                      style={{ textDecoration: "underline", cursor: "pointer" }}
                      onClick={() => navigate("/registeredUser/recent")}
                      className="p-0 m-0"
                    >
                      ...view all
                    </p>
                  </span>
                  <Table className="dashboard-single-tabel">
                    <thead>
                      <tr>
                        {" "}
                        <th scope="col">Sr No.</th>
                        <th scope="col">Mobile Number</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.recentUsers?.length > 0 ? (
                        data?.recentUsers?.map((res, index) => {
                          return (
                            <tr>
                              <td>{index + 1}</td>
                              <td>
                                <div className="d-flex justify-content-between align-items-center bg-white">
                                  <span className="bg-white text-dark">
                                    {res?.phone}
                                  </span>
                                  <CopyToClipboard
                                    onCopy={() => toast.success("Copied!")}
                                    text={res?.phone || "-"}
                                  >
                                    <FaRegCopy style={{ cursor: "pointer" }} />
                                  </CopyToClipboard>
                                </div>{" "}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={2}>No Record Found</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </Col>
            </Row>
          )}
        </Container>
      </section>
      <Modal
              show={code?.status}
              onHide={() => {
                setCode({ status: false });
              }}
              className="change-status-modal p-0"
            >
              <Modal.Header closeButton>
                <Modal.Title className="modal-title-status h4">
                  Update Referal Code
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="test-status border-0">
                  <Form
                    className="change-password-sec"
                    onSubmit={handleSubmit(updateRefrel)}
                  >
                    <Form.Group className="d-flex  mb-2">
                      <Form.Control
                        type="text"
                       
                        placeholder="Referal Code"
                        className={errors.referalCode ? " is-invalid " : ""}
                        {...register("referalCode", {
                          required: "Please enter referal code",
                        })}
                      />
                      {errors.referalCode && errors.referalCode.message && (
                        <label
                          className="invalid-feedback align-leftt"
                        >
                          {errors.referalCode.message}
                        </label>
                      )}
                    </Form.Group>
      
                    <div className="text-center mt-4">
                      <Button type="submit" className="green-btn">
                        Update
                      </Button>
                    </div>
                  </Form>
                </div>
              </Modal.Body>
            </Modal>
    </div>
  );
};

export default Dashboard;